export const contacts: Contact[] = [
  {
    avatarUrl: 'https://i.pravatar.cc/100?u=ullamvoluptatemnulla',
    name: 'Berti Brockhurst',
    telephone: '593-873-6488',
    email: 'bbrockhurst0@google.fr',
    address: '6609 Oakridge Junction',
    jobTitle: 'Dental Hygienist'
  },
  {
    avatarUrl: 'https://i.pravatar.cc/100?u=sintvoluptatequia',
    name: 'Isidore Rodgerson',
    telephone: '284-832-1689',
    email: 'irodgerson1@1und1.de',
    address: '43718 Bunker Hill Court',
    jobTitle: 'Account Representative III'
  },
  {
    avatarUrl: 'https://i.pravatar.cc/100?u=doloremcorruptideserunt',
    name: 'Nikaniki Tinham',
    telephone: '634-421-2464',
    email: 'ntinham2@huffingtonpost.com',
    address: '6402 Havey Way',
    jobTitle: 'Director of Sales'
  },
  {
    avatarUrl: 'https://i.pravatar.cc/100?u=quibusdamquidemaut',
    name: 'Devlen Matchett',
    telephone: '597-777-5578',
    email: 'dmatchett3@house.gov',
    address: '3 Dawn Street',
    jobTitle: 'Nuclear Power Engineer'
  },
  {
    avatarUrl: 'https://robohash.org/aliquaminrepellat.png?size=50x50&set=set1',
    name: 'Kienan Dwane',
    telephone: '863-552-6442',
    email: 'kdwane4@uol.com.br',
    address: '297 Coolidge Hill',
    jobTitle: 'Financial Analyst'
  },
  {
    avatarUrl: 'https://i.pravatar.cc/100?u=molestiaefugiteveniet',
    name: 'Derrik Ledner',
    telephone: '528-892-8358',
    email: 'dledner5@geocities.com',
    address: '83799 Bellgrove Alley',
    jobTitle: 'Chemical Engineer'
  },
  {
    avatarUrl: 'https://robohash.org/quianecessitatibusat.png?size=50x50&set=set1',
    name: 'Barth Goodliffe',
    telephone: '807-458-1437',
    email: 'bgoodliffe6@ed.gov',
    address: '991 Sloan Parkway',
    jobTitle: 'Civil Engineer'
  },
  {
    avatarUrl: 'https://i.pravatar.cc/100?u=nisisintasperiores',
    name: 'Barbette Rapier',
    telephone: '739-273-7640',
    email: 'brapier7@surveymonkey.com',
    address: '464 Forest Court',
    jobTitle: 'Compensation Analyst'
  },
  {
    avatarUrl: 'https://i.pravatar.cc/100?u=doloresvoluptatibusab',
    name: 'Beverlie Rummery',
    telephone: '879-160-0893',
    email: 'brummery8@cyberchimps.com',
    address: '0 Anhalt Place',
    jobTitle: 'Project Manager'
  },
  {
    avatarUrl: 'https://robohash.org/laborumquamsit.png?size=50x50&set=set1',
    name: 'Ruprecht Andren',
    telephone: '360-408-6441',
    email: 'randren9@hhs.gov',
    address: '62672 Shasta Trail',
    jobTitle: 'GIS Technical Architect'
  },
  {
    avatarUrl: 'https://i.pravatar.cc/100?u=laborumperspiciatisconsectetur',
    name: 'Sella Pottery',
    telephone: '365-598-1254',
    email: 'spotterya@amazon.com',
    address: '672 Calypso Junction',
    jobTitle: 'Recruiter'
  },
  {
    avatarUrl: 'https://i.pravatar.cc/100?u=quiquosvelit',
    name: 'Gretna Petcher',
    telephone: '680-422-8589',
    email: 'gpetcherb@arizona.edu',
    address: '0516 Manitowish Point',
    jobTitle: 'Director of Sales'
  },
  {
    avatarUrl: 'https://i.pravatar.cc/100?u=adsuntoccaecati',
    name: 'Clarine Hiseman',
    telephone: '775-235-3713',
    email: 'chisemanc@discuz.net',
    address: '5 Farwell Way',
    jobTitle: 'Accountant IV'
  },
  {
    avatarUrl: 'https://i.pravatar.cc/100?u=dictaofficiamodi',
    name: 'Inessa Ormesher',
    telephone: '662-576-0173',
    email: 'iormesherd@cnn.com',
    address: '48857 Milwaukee Circle',
    jobTitle: 'Civil Engineer'
  },
  {
    avatarUrl: 'https://i.pravatar.cc/100?u=animiculpamaxime',
    name: 'Merwyn Brady',
    telephone: '466-295-9247',
    email: 'mbradye@hugedomains.com',
    address: '71092 Montana Park',
    jobTitle: 'Nurse Practicioner'
  }
];

export interface Contact {
  avatarUrl: string;
  name: string;
  telephone: string;
  address: string;
  email: string;
  jobTitle: string;
}

